import React, { useEffect } from 'react';

const BreadcrumbJsonLd: React.FC = () => {
    useEffect(() => {
        const injectJsonLd = () => {
            if (document.getElementById('breadcrumb-json-ld')) return;

            const breadcrumbElements = document.querySelectorAll('.ms-breadcrumb_item');

            if (breadcrumbElements.length === 0) {
                setTimeout(injectJsonLd, 500);
                return;
            }

            const breadcrumbItems: { '@type': string; position: number; name: string; item: string }[] = [];

            breadcrumbElements.forEach((el, index) => {
                const anchor = el.querySelector('a');
                breadcrumbItems.push({
                    '@type': 'ListItem',
                    position: index + 1,
                    name: anchor ? anchor.textContent!.trim() : el.textContent!.trim(),
                    item: anchor ? anchor.href : window.location.href
                });
            });

            if (breadcrumbItems.length > 0) {
                const jsonLd = {
                    '@context': 'https://schema.org',
                    '@type': 'BreadcrumbList',
                    itemListElement: breadcrumbItems
                };

                const script = document.createElement('script');
                script.id = 'breadcrumb-json-ld';
                script.type = 'application/ld+json';
                script.textContent = JSON.stringify(jsonLd);
                document.head.appendChild(script);
            }
        };

        injectJsonLd();

        return () => {
            document.getElementById('breadcrumb-json-ld')?.remove();
        };
    }, []);

    return null;
};

export default BreadcrumbJsonLd;
